export const calculatePrice = (price, divider) => {
  return price / divider;
};
